import { render, staticRenderFns } from "./horizontal-scroll.vue?vue&type=template&id=3f9c8340&scoped=true"
import script from "./horizontal-scroll.vue?vue&type=script&lang=js"
export * from "./horizontal-scroll.vue?vue&type=script&lang=js"
import style0 from "./horizontal-scroll.vue?vue&type=style&index=0&id=3f9c8340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c8340",
  null
  
)

export default component.exports